import { GiftCard } from 'state/giftCard';
import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export function getGiftCardBalance(giftCard: GiftCard): ApiAction {
  const { provider, number, pin } = giftCard;
  return {
    TockApi: {
      getProto: `/giftcard/${provider.toLowerCase()}/${number}/balance${pin ? '?pin=' + pin : ''}`,
      type: AppConstants.GIFT_CARD_GET_BALANCE,
    },
  };
}

export function applyGiftCard(card: GiftCard): BaseTockAction {
  return {
    type: AppConstants.APPLY_GIFT_CARD,
    payload: card,
  };
}

export function removeGiftCard(giftCardNumber: string): BaseTockAction {
  return {
    type: AppConstants.REMOVE_GIFT_CARD,
    context: { giftCardNumber },
  };
}

export function clearAllGiftCards(provider?: core.Business.GiftCardProvider): BaseTockAction {
  return {
    type: AppConstants.GIFT_CARD_CLEAR,
    payload: provider,
  };
}

export function addTockGiftCard(tockGiftCard: core.TockGiftCard): BaseTockAction {
  return {
    type: AppConstants.TOCK_GIFT_CARD_ADDED,
    payload: tockGiftCard,
  };
}

export function removeTockGiftCard(): BaseTockAction {
  return {
    type: AppConstants.TOCK_GIFT_CARD_REMOVED,
  };
}
